import { render, staticRenderFns } from "./FormsApp.vue?vue&type=template&id=73800860&scoped=true"
import script from "./FormsApp.vue?vue&type=script&lang=js"
export * from "./FormsApp.vue?vue&type=script&lang=js"
import style0 from "./FormsApp.vue?vue&type=style&index=0&id=73800860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73800860",
  null
  
)

export default component.exports